'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});
function PriceListController($scope, $filter, $window, $stateParams, PageHeading, Line, LineComponent, AppConstants, PriceComponent, Toast) {
	'ngInject';

	var vm = this;
	vm.clickHandler = clickHandler;
	vm.getLine = LineComponent.getLine;
	vm.fetchAllPrices = PriceComponent.fetchAllPrices;
	vm.getAllPrices = PriceComponent.getAllPrices;
	vm.getPrices = PriceComponent.getPrices;
	vm.editPrice = editPrice;
	vm.updatePrice = updatePrice;
	vm.deletePrice = deletePrice;
	vm.couplePoints = [];
	vm.points = [];
	vm.updatingPrices = [];
	vm.isNumerous = 0;
	vm.refreshFetchPrices = refreshFetchPrices;
	vm.onePriceForAllSubLine = onePriceForAllSubLine;
	vm.isOnePriceForAllSubLine = 0;
	vm.timeoutSearch = timeoutSearch;
	vm.totalPrice = 0;
	vm.getPaginationInfo = PriceComponent.getPaginationInfo;
	vm.lineId = Line.id;
	vm.showLoading = false;
	activate();

	function activate() {
		var heading = $filter('translate')('PRICES_FOR_LINE') + ' ' + Line.translation.name;
		var title = 'BTMS | ' + $filter('translate')('SIDEBAR.PRICES');
		PageHeading.setPageHeading(heading, title);
		setPoints();
	}

	function clickHandler(event, point, index) {
		$scope.$apply(function () {
			if (vm.couplePoints.length < 2) {
				addCouplePoint(point, index);
			} else {
				cleaningCouplePoints();
				addCouplePoint(point, index);
			}

			vm.redraw();
		});
	}

	/**
  * When select price(sub line) from list with prices
  * @param subLine
  */
	function editPrice(subLine) {
		if (vm.couplePoints.length > 0) {
			cleaningCouplePoints();
		}

		var fromStation = { 'city': { 'translation': {} }, 'station': {} };
		var toStation = { 'city': { 'translation': {} }, 'station': {} };

		fromStation.city.translation = subLine.from_station.city.translation;
		fromStation.city.id = subLine.from_station.city.id.toString();
		fromStation.station.id = subLine.from_station.id.toString();
		fromStation.station.name = subLine.from_station.translation.name;
		vm.points.forEach(function (value, index) {
			if (value.station.id === subLine.from_station.id.toString()) {
				fromStation.index = index;
			}
		});
		addCouplePoint(fromStation, fromStation.index);

		toStation.city.translation = subLine.to_station.city.translation;
		toStation.city.id = subLine.to_station.city.id.toString();
		toStation.station.id = subLine.to_station.id.toString();
		toStation.station.name = subLine.to_station.translation.name;
		vm.points.forEach(function (value, index) {
			if (value.station.id === subLine.to_station.id.toString()) {
				toStation.index = index;
			}
		});
		addCouplePoint(toStation, toStation.index);
		vm.redraw();
	}

	function addCouplePoint(point, index) {
		// vm.points[index].color = AppConstants.colors.activeIndigo;
		vm.points[index].active = true;
		if (vm.couplePoints.length === 1 && vm.couplePoints[0].station.id === vm.points[index].station.id) {
			return false;
		} else {
			point.index = index;
			// Check position(index) of stations and revert for correct direction
			if (vm.couplePoints.length === 1 && vm.couplePoints[0].index > index) {
				vm.couplePoints.splice(0, 0, point);
			} else {
				vm.couplePoints.push(point);
				PriceComponent.cleanPrices();
			}
		}

		if (vm.couplePoints.length === 2) {
			refreshFetchPrices();
		}
	}

	function refreshFetchPrices() {
		var numerous = arguments.length <= 0 || arguments[0] === undefined ? 0 : arguments[0];

		PriceComponent.fetchPrices(Line.id, vm.couplePoints[0].station.id, vm.couplePoints[1].station.id, numerous).then(function () {
			pushUpdatingPrices();
		});
	}

	function pushUpdatingPrices() {
		vm.updatingPrices = [];
		PriceComponent.getPrices().forEach(function (subLine) {
			vm.updatingPrices.push({ 'sub_line_id': subLine.id, 'value': subLine.price });
		});
	}

	function onePriceForAllSubLine(showAll) {
		vm.isOnePriceForAllSubLine = showAll;
		vm.totalPrice = 0;
		if (vm.isOnePriceForAllSubLine === 0) {
			refreshFetchPrices(vm.isNumerous);
		}
		timeoutSearch();
	}

	function timeoutSearch() {
		var query = arguments.length <= 0 || arguments[0] === undefined ? 0 : arguments[0];

		vm.updatingPrices.forEach(function (price) {
			price.value = query;
		});
	}

	function cleaningCouplePoints() {
		vm.points[vm.couplePoints[0].index].active = false;
		vm.points[vm.couplePoints[1].index].active = false;
		vm.couplePoints = [];
		vm.updatingPrices = [];
		vm.isNumerous = 0;
		vm.isOnePriceForAllSubLine = 0;
	}

	function setPoints() {
		vm.points = [];
		// Sort stations by position
		LineComponent.getLine().stations.sort(function (a, b) {
			return a.pivot.position - b.pivot.position;
		});

		LineComponent.getLine().stations.forEach(function (station) {
			vm.points.push({
				'city': {
					'id': station.city.id.toString(),
					'translation': station.city.translation
				},
				'station': {
					'id': station.id.toString(),
					'name': station.translation.name
				},
				'name': station.city.translation.name,
				'active': false
			});
		});
	}

	function updatePrice(subLine, form) {
		var hasErrors = false;
		angular.forEach(form.$error.min, function () {
			hasErrors = true;

			return false;
		});

		if (hasErrors) {
			Toast.error($filter('translate')('ERRORS.GENERAL'));

			return false;
		}

		// if field with price is null, set 0 for value
		subLine.forEach(function (price) {
			if (price.value === null) {
				price.value = 0;
			}
		});

		form.$setPristine();
		PriceComponent.updatePrice(subLine).then(function (response) {
			if (response.data.errors) {
				Toast.responseError(response.data.errors);
			} else {
				vm.fetchAllPrices($stateParams.lineId);
				cleaningCouplePoints();
				vm.redraw();
				Toast.success($filter('translate')('SUCCESS.UPDATE_PRICE'));
			}
		});
	}

	function deletePrice(id) {
		if ($window.confirm($filter('translate')('CONFIRM.DELETE'))) {
			PriceComponent.deletePrice(id).then(function (res) {
				if (res.data.errors) {
					Toast.responseError(res.data.errors);
				} else {
					Toast.success($filter('translate')('SUCCESS.DELETE_PRICE'));
					vm.fetchAllPrices($stateParams.lineId);
				}
			});
		}
	}
}

exports['default'] = PriceListController;
module.exports = exports['default'];


/** WEBPACK FOOTER **
 ** ./client/private/prices/list/list.controller.js
 **/